export const FILE_UPLOAD_LOADING  = "FILE_UPLOAD_LOADING";
export const FILE_UPLOAD_SUCCESS  = "FILE_UPLOAD_SUCCESS";
export const FILE_UPLOAD_ERROR = "FILE_UPLOAD_ERROR";
